var map = {
	"./events-cat-cn.webp": 1995,
	"./events-cat.webp": 1996,
	"./games-cat.webp": 1997,
	"./live-casino-cat-cn.webp": 1998,
	"./live-casino-cat.webp": 1999,
	"./lottery-cat.webp": 2000,
	"./other-cat.webp": 2001,
	"./p2p-cat.webp": 2002,
	"./pd-table.webp": 2003,
	"./privacy-policy-title-bm.webp": 2004,
	"./privacy-policy-title-cn.webp": 2005,
	"./privacy-policy-title-id.webp": 2006,
	"./privacy-policy-title.webp": 2007,
	"./promos-1.webp": 2008,
	"./promos-2.webp": 2009,
	"./promos-3.webp": 2010,
	"./promos-4.webp": 2011,
	"./question.webp": 2012,
	"./sideBar-bg.webp": 2013,
	"./slot-cat-cn.webp": 2014,
	"./slot-cat.webp": 2015,
	"./special-cat-cn.webp": 2016,
	"./special-cat.webp": 2017,
	"./sports-cat-cn.webp": 2018,
	"./sports-cat.webp": 2019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;